import { createSlice } from '@reduxjs/toolkit';
import {
  deletePromotion,
  getPromotionList,
  updatePromotion,
} from './promotionListThunk';
import { PromotionData, PromotionListModalType } from '../types/index';

interface PromotionListState {
  loading: boolean;
  promotions: PromotionData[];
  modal: PromotionListModalType[];
  selected?: { name: string; id: number };
  meta: {
    itemsPerPage?: number;
    totalItems?: number;
    currentPage?: number;
    totalPages?: number;
  };
  params: {
    page: number;
    limit: number;
    search: string;
  };
}

const initialState: PromotionListState = {
  loading: true,
  promotions: [],
  modal: [],
  meta: {},
  params: {
    page: 1,
    limit: 20,
    search: '',
  },
};

const promotionSlice = createSlice({
  name: 'coupons',
  initialState,
  reducers: {
    onChangeSearchValue(state, { payload }) {
      state.params.search = payload;
    },
    onChangePage(state, { payload }) {
      state.params.page = payload;
    },
    onChangeModal(state, { payload }) {
      if (payload === 'off') {
        state.modal = [];
      } else if (state.modal.includes(payload)) {
        state.modal = state.modal.filter((modal) => modal !== payload);
      } else {
        state.modal = [...state.modal, payload];
      }
    },
    onActionSelected(state, { payload }) {
      state.selected = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPromotionList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPromotionList.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.promotions = payload.data;
        state.meta = payload.meta;
      })
      .addCase(getPromotionList.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(deletePromotion.fulfilled, (state, { payload }) => {
        state.promotions = state.promotions.filter(
          (promotion) => promotion.id !== payload
        );
      })
      .addCase(deletePromotion.rejected, (_, { payload }) => {
        throw payload;
      });

    builder.addCase(updatePromotion.rejected, (_, { payload }) => {
      throw payload;
    });
  },
});

export const {
  onChangeSearchValue,
  onChangePage,
  onChangeModal,
  onActionSelected,
} = promotionSlice.actions;
export default promotionSlice.reducer;
